if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const formData = new FormData(this.form);

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        const quantityToAdd = parseInt(formData.get("quantity"), 10) || 1;
        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();
        const productId = formData.get("id")
        if (productId){
        const existingProductInCart = cartData.items.find(
          (item) => item.variant_id === parseInt(productId)
        );
        const variantLimit = shopLimit.variants_limit;
        const cartLimit = shopLimit.cart_limit;

        const currentQuantity = existingProductInCart
          ? existingProductInCart.quantity
          : 0;
          const limit_msg = document.querySelector(".limit_msg");
        // Check for variant limit
        const variantEnable = shopLimit.enable_variants_limits;
        if (variantEnable === true) {
          if (currentQuantity + quantityToAdd > variantLimit) {
          
            limit_msg.innerText = `You have reached the maximum purchase limit for this size, please choose  another product or size.`;
            this.submitButton.setAttribute('aria-disabled', false);
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading__spinner').classList.add('hidden');
            return;
          }
        } else{
          limit_msg.innerText = ''
        }

        // Check for cart limit
        const cartEnable = shopLimit.enable_cart_limit;
        if (cartEnable === true) {
          const currentCartQuantity = cartData.items.reduce(
            (total, item) => total + item.quantity,
            0
          );
          if (currentCartQuantity + quantityToAdd > cartLimit) {
           
            limit_msg.innerText = `You have reached the maximum cart quantity limit`;
            this.submitButton.setAttribute('aria-disabled', false);
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading__spinner').classList.add('hidden');
            return;
          } else{
            limit_msg.innerText = ''
          }
        }
      }
        // Continue with your regular handling if no limit is exceeded
        this.handleErrorMessage();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const productAddToCartNotificationWrapper = document.querySelector('.product-add-to-cart-notification-wrapper'),
          showProductAddToCartNotification = productAddToCartNotificationWrapper !== null && productAddToCartNotificationWrapper !== undefined,
          openCartDrawer = !showProductAddToCartNotification;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              if (showProductAddToCartNotification) {
                productAddToCartNotificationWrapper.style.display = 'block';
                setTimeout(function () {
                  productAddToCartNotificationWrapper.style.display = 'none';
                }, 3000);
              }

              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response, openCartDrawer);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response, openCartDrawer);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
